import React from 'react'
import styled from 'styled-components'
import styledTheme from '../../styles/theme'

import SiteHeader from '../../containers/layout/SiteHeader'
import SiteFooter from './SiteFooter'

import { ScreenWidthContainer } from '../../styles/styled-elements'

const SiteWrapper = styled.div`
  display: flex;
  flex-direction: column;
  min-height: ${window.innerHeight}px;
  width: 100%;
`
const MainContent = styled.div`
  margin-top: 70px;
  background-color: rgba(221,225,231,0.5);
  flex: 1;
  display: flex;
  flex-direction: column;
  @media (min-width: 0px) {
    padding: 10px;
    padding-top: 16px;
  };
  @media (min-width: ${styledTheme.breakpoints.md}px) {
    padding: 20px;
  };
`

const SiteContainer = ({ children, isSignedIn }) => {
  return <ScreenWidthContainer>
    <SiteWrapper>
      <SiteHeader />
      <MainContent>
        {children}
      </MainContent>
    </SiteWrapper>
  </ScreenWidthContainer>
}

export default SiteContainer



// WEBPACK FOOTER //
// ./src/components/layout/SiteContainer.js